import "./CopyableText.css";

import { Typography } from "antd";
import CheckIcon from "@/icons/CheckIcon";
import DuplicateIcon from "@/icons/DuplicateIcon";

const { Paragraph } = Typography;

const CopyableText = ({
  text = "",
  children,
  className,
  hoverable = false,
}) => {
  const duplicateIconStyle = {
    fontSize: 18,
    color: "#BBBBBB",
    verticalAlign: "middle",
  };

  const checkIconStyle = {
    fontSize: 18,
    verticalAlign: "middle",
  };

  const wrapperClass = `${className ? className : ""} ${
    hoverable ? "copyable-hoverable" : ""
  }`;

  return (
    (text || children) && (
      <div className={wrapperClass} style={{ display: "inline-block" }}>
        <Paragraph
          copyable={{
            text: text,
            icon: [
              <span className="copyable-icon">
                <DuplicateIcon style={duplicateIconStyle} />
              </span>,
              <span className="copyable-icon">
                <CheckIcon style={checkIconStyle} />
              </span>,
            ],
            tooltips: ["Копировать", "Скопировано"],
          }}
          style={{ margin: 0, fontSize: 13 }}
        >
          {children ? children : text}
        </Paragraph>
      </div>
    )
  );
};

export default CopyableText;
